import { Injectable, EventEmitter, OnInit } from "@angular/core";
import { UserAuthModel } from "./model/agro.user.model";

const TOKEN_KEY = "authToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const USER_KEY = "userLogged";
const LAST_USER_NAME_KEY = "lastUserName";
const DESCRIPTION_NAME_KEY = "descriptionName";
const TOKEN_LOGIN = "C73-4FD36A087A68FA7F933D8AE1F-CF470993CE3F5E8A11B160E47-47B7B7AB9CE4DDFE372668235-F0C71B4B128DC4AC8CED6EFB1-61DB9BA362E52AFF514C4BFDB";

/**
 * Serviço responsável em manter funções utilitárias de Token de Sessão.
 */
@Injectable()
export class UserTokenService {

    enableMenuAgro = new EventEmitter<boolean>();

    /**
     * Verifica se existe token armazenado localmente.
     */
    hasToken(): boolean {
        return !!this.getToken();
    };

    /**
     * Verifica se existe usuário armazenado localmente.
     */
    hasUser(): boolean {
        return !!this.getUser();
    };

    /**
     * Verifica se existe Refesh Token localmente.
     */
    hasRefreshToken(): boolean {
        return !!this.getRefreshToken();
    };

    /**
     * Verifica se existe ultimo userName.
     */
    hasLastUserName(): boolean {
        return !!this.getLastUserName();
    };

    /**
     * Verifica se existe description Name.
     */
    hasDescriptionName(): boolean {
        return !!this.getDescriptionName();
    };

    /**
     * Seta um novo Token localmente.
     * @param token 
     */
    setToken(token: string): void {
        window.localStorage.setItem(TOKEN_KEY, btoa(token));
    };

    /**
     * Seta um novo UserName
     * @param userName 
     */
    setLastUserName(userName: string): void {
        window.localStorage.setItem(LAST_USER_NAME_KEY, btoa(userName));
    };

    /**
     * Seta um novo Usuário localmente.
     * @param user 
     */
    setUser(user: UserAuthModel): void {
        window.localStorage.setItem(USER_KEY, btoa(JSON.stringify(user)));
        this.enableMenuAgro.emit(true);
    };

    /**
     * Seta um novo Refresh Token localmente.
     * @param refreshToken 
     */
    setRefreshToken(refreshToken: string): void {
        window.localStorage.setItem(REFRESH_TOKEN_KEY, btoa(refreshToken));
    };

    /**
     * Set descrição do nome para Escolha de instância
     * @param description 
     */
    setDescriptionName(description: string): void {
        window.localStorage.setItem(DESCRIPTION_NAME_KEY, btoa(description));
    };

    /**
     * Captura Descrição do Nome.
     */
    getDescriptionName(): string {
        let descriptionName = window.localStorage.getItem(DESCRIPTION_NAME_KEY);

        if (descriptionName) {

            try {
                descriptionName = atob(descriptionName);
            } catch (error) {
                return null;
            }
        }

        return descriptionName;
    };

    /**
     * Captura um token armazenado localmente.
     */
    getToken(): string {
        let token = window.localStorage.getItem(TOKEN_KEY);

        if (token) {

            let _token = "";

            try {
                _token = atob(token);
            } catch (error) {
                return null;
            }

            return `Bearer ${_token}`;
        }

        return null;
    };

    /**
     * Captura um usuário armazenado Localmente.
     */
    getUser(): UserAuthModel {
        let _usuario = window.localStorage.getItem(USER_KEY);

        if (_usuario != null) {

            try {

                let _user = atob(_usuario)
                return JSON.parse(_user);

            } catch (error) {
                return null;
            }
        }

        return null;
    };

    /**
     * Captura um Refresh Token armazenado Localmente.
     */
    getRefreshToken(): string {

        let refreshToken = window.localStorage.getItem(REFRESH_TOKEN_KEY);

        if (refreshToken) {

            try {

                let _refreshToken = atob(refreshToken);
                return _refreshToken;

            } catch (error) {
                return null;
            }

        }

        return null;
    };

    /**
     * Captura ultimo user Name.
     */
    getLastUserName(): string {

        let lastUserName = window.localStorage.getItem(LAST_USER_NAME_KEY);

        if (lastUserName) {

            try {

                return atob(lastUserName);

            } catch (error) {
                return null;
            }
        }
        
        return null;
    };

    /**
     * Remove a Descrição do Nome.
     */
    removeDescriptionName(): void {
        window.localStorage.removeItem(DESCRIPTION_NAME_KEY);
    };

    /**
     * Remove o token localmente.
     */
    removeToken(): void {
        window.localStorage.removeItem(TOKEN_KEY);
    };

    /**
     * Remove usuário localmente.
     */
    removeUser(): void {
        window.localStorage.removeItem(USER_KEY);
    };

    /**
     * Remove Refresh Token locamente.
     */
    removeRefreshToken(): void {
        window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    };

    /**
     * Remove Last User Name.
     */
    removeLastUserName(): void {
        window.localStorage.removeItem(LAST_USER_NAME_KEY);
    };

    /**
     * Retorna Token do Login.
     */
    getTokenLogin(): string {
        return TOKEN_LOGIN;
    };

    /**
     * Remove usuário e token localmente.
     */
    removeAll(): void {
        this.removeToken();
        this.removeUser();
        this.removeRefreshToken();
        this.removeDescriptionName();
        this.removeLastUserName();
    };

    /**
     * Start Login
     */
    logout(): void {
        this.removeToken();
        this.removeRefreshToken();
        this.removeUser();
        this.removeDescriptionName();
        this.enableMenuAgro.emit(false);
    };

    /**
     * Responsável em iniciar tela de selecionar instâncias.
     */
    startUnidAdm(): void {
        this.removeUser();
        this.enableMenuAgro.emit(false);
    };

    /**
     * Responsável em verifica se usuário encontra-e autenticado.
     */
    isAuthenticated(): boolean {
        if (this.hasToken() && this.hasUser()) {
            this.enableMenuAgro.emit(true);
            return true;
        } else {
            this.enableMenuAgro.emit(false);
            return false;
        }
    };

    getLocale(): string {

        if (this.hasUser()) {
            let locale = this.getUser().locale;

            return locale.replace("_", "-").toLowerCase();

        }

        let idioma = navigator.language.toLowerCase();
        let _idioma = idioma.split("-");

        return `${_idioma[0].toLocaleLowerCase()}_${_idioma[1].toLocaleUpperCase()}`

    }
}